import { useField, ErrorMessage } from "formik";
import React from "react";

import { TQuestionOption } from "../types";

import QuestionCopy from "./QuestionCopy";
import QuestionWrapper from "./QuestionWrapper";

type TQuestionSelectProps = {
  name: string;
  label?: string;
  note?: string;
  options: TQuestionOption[];
  error?: boolean;
};

const QuestionSelect: React.FC<TQuestionSelectProps> = ({ name, label, note, options, error }) => {
  const [field] = useField(name);

  return (
    <QuestionWrapper>
      <QuestionCopy name={name} label={label} note={note} />
      <br />
      <select
        placeholder="Please choose"
        style={{
          width: "100%",
          maxWidth: "343px",
          height: "48px",
          borderRadius: "3px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
          color: "#222221CC",
          fontSize: "16px",
          paddingLeft: "1rem",
          border: "none",
          appearance: "none",
          position: "relative",
          outline: error ? "1px solid" : undefined,
          outlineColor: error ? "#D82727" : undefined,
          MozAppearance: "none",
          WebkitAppearance: "none",
        }}
        {...field}
      >
        <option value=""></option>
        {options.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <svg
        style={{ marginLeft: "-30px", position: "relative", pointerEvents: "none" }}
        width="15"
        height="10"
        viewBox="0 0 15 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.918 2L7.95922 7.95875L2.00047 2"
          stroke="#1E9E81"
          stroke-width="1.5"
          stroke-linecap="square"
        />
      </svg>
      <ErrorMessage name={name}>
        {(msg) => <p style={{ fontSize: "14px", color: "#D82727" }}>{msg}</p>}
      </ErrorMessage>
    </QuestionWrapper>
  );
};

export default QuestionSelect;
